const groupBy = <T, K extends PropertyKey>(arr: T[], key: (i: T) => K) =>
  arr.reduce((groups, item) => {
    (groups[key(item)] ||= []).push(item)
    return groups
  }, {} as Record<K, T[]>)

const unwrap = <T>(arr: unknown[], keys: string[]): T[] => {
  let current = arr
  for (const key of keys) {
    current = current.flatMap(item => (item as Record<string, unknown> | null | undefined)?.[key] ?? [])
  }
  return current as T[]
}

const partition = <T>(arr: T[], predicate: (value: T) => boolean): [T[], T[]] => {
  const p1: T[] = []
  const p2: T[] = []

  for (const item of arr) {
    if (predicate(item)) {
      p1.push(item)
    } else {
      p2.push(item)
    }
  }

  return [p1, p2]
}

export { groupBy, unwrap, partition }
